import { IpnDialog } from 'app/components/Profile/Ids/IpnDialog';
import { IdType } from 'types/enums';
import { IpiDialog } from 'app/components/Profile/Ids/IpiDialog';
import { IsniDialog } from 'app/components/Profile/Ids/IsniDialog';
import { ChakraConfirmationDialog } from 'app/components/Dialogs';
import { getDeleteMessage } from 'app/components/Profile/Ids/IdsList/constants';
import {
  ConfirmClaimDialog,
  EmailClaimDialog,
} from 'app/components/Profile/Ids/ClaimDialogs';
import { Ipn } from 'types/ipn.types';
import {
  IdProps,
  SocietyOption,
  V3Claim,
} from 'app/components/Profile/Ids/types';
import { Ipi } from 'types/ipi.types';
import { Isni } from 'types/isni.types';
import { UseDisclosureReturn } from '@chakra-ui/react';

interface IdsListDialogsProps {
  addId: IdType | null;
  handleIdDialogClose: () => void;
  v3Claim?: V3Claim;
  updateV3ClaimVerificationData: (data: SocietyOption) => void;
  emailConfirmDisclosure: UseDisclosureReturn;
  onConfirmClaimDialogClose: () => void;
  verificationDisclosure: UseDisclosureReturn;
  requestGuidForVerification?: string;
  onEmailClaimDialogClose: (
    needConfirm?: boolean,
    requestGuid?: string
  ) => void;
  ipnProps: IdProps<Ipn>;
  ipiProps: IdProps<Ipi>;
  isniProps: IdProps<Isni>;
}

export const IdsListDialogs = ({
  addId,
  handleIdDialogClose,
  updateV3ClaimVerificationData,
  v3Claim,
  emailConfirmDisclosure,
  verificationDisclosure,
  requestGuidForVerification,
  onConfirmClaimDialogClose,
  onEmailClaimDialogClose,
  ipnProps,
  ipiProps,
  isniProps,
}: IdsListDialogsProps) => {
  return (
    <>
      <IpnDialog
        key={ipnProps.idToUpdate?.ipnReference}
        open={addId === IdType.IPN || Boolean(ipnProps.idToUpdate)}
        ipn={ipnProps.idToUpdate}
        onV3Verification={updateV3ClaimVerificationData}
        onClose={handleIdDialogClose}
      />
      <IpiDialog
        key={ipiProps.idToUpdate?.ipiReference}
        open={addId === IdType.IPI || Boolean(ipiProps.idToUpdate)}
        ipi={ipiProps.idToUpdate}
        onV3Verification={updateV3ClaimVerificationData}
        onClose={handleIdDialogClose}
      />
      <IsniDialog
        onClose={handleIdDialogClose}
        open={addId === IdType.ISNI || Boolean(isniProps.idToUpdate)}
        isni={isniProps.idToUpdate}
      />
      <ChakraConfirmationDialog
        title="Delete ID"
        actionButtonText="Delete"
        message={getDeleteMessage(
          IdType.IPI,
          ipiProps.idToDelete?.ipiNameNumber
        )}
        isOpen={Boolean(ipiProps.idToDelete)}
        handleAction={ipiProps.handleDeleteId}
        onClose={() => ipiProps.setIdToDelete(undefined)}
      />
      <ChakraConfirmationDialog
        title="Delete ID"
        actionButtonText="Delete"
        message={getDeleteMessage(IdType.IPN, ipnProps.idToDelete?.ipnNumber)}
        isOpen={Boolean(ipnProps.idToDelete)}
        handleAction={ipnProps.handleDeleteId}
        onClose={() => ipnProps.setIdToDelete(undefined)}
      />
      <ChakraConfirmationDialog
        title="Delete ID"
        actionButtonText="Delete"
        message={getDeleteMessage(IdType.ISNI, isniProps.idToDelete?.isni)}
        isOpen={Boolean(isniProps.idToDelete)}
        handleAction={isniProps.handleDeleteId}
        onClose={() => isniProps.setIdToDelete(undefined)}
      />
      <EmailClaimDialog
        societyName={v3Claim?.societyName}
        societyId={v3Claim?.id}
        open={emailConfirmDisclosure.isOpen}
        onClose={onEmailClaimDialogClose}
      />
      <ConfirmClaimDialog
        open={verificationDisclosure.isOpen}
        requestGuid={requestGuidForVerification}
        onClose={onConfirmClaimDialogClose}
      />
    </>
  );
};
